import HasDropDown from '../utils/hasDropDown'
import HoverJs from '../plugins/hoverJs'

const initHasDropDown = () => {
  const menuItems = document.querySelectorAll('.user-dropdown__list')[0]

  if (!menuItems) {
    return
  }

  const hasDropDown = new HasDropDown(menuItems, {
    items: 'li',
    drop: '.user-dropdown__sublist',
    link: 'a',
    dropClass: 'has-dropdown',
    linkClass: 'has-dropdown-a'
  })
  hasDropDown.init()
}

const initHoverJs = () => {
  const menuHolder = document.querySelectorAll('.user-dropdown__list')

  if (!menuHolder) {
    return
  }

  menuHolder.forEach((el) => {
    const hoverJs = new HoverJs(el, {
      dropClass: '.has-dropdown',
      linkClass: '.has-dropdown-a',
      activeClass: 'hover-js'
    })
    hoverJs.init()
  })
}

export { initHasDropDown, initHoverJs }
